type SortType = "default" | "sku" | "scale" | "price";

import { initIcons } from "../icons";
import { initPrices } from "../utils/locale";

document.addEventListener("DOMContentLoaded", () => {
    initProductList();
});

export function initProductList() {
    initPrices();

    const grid = document.getElementById("productGrid") as HTMLElement;
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll<HTMLElement>(".product-item"));
    const originalOrder = [...items];

    const searchInput = document.getElementById("productSearch") as HTMLInputElement | null;
    const sortButtons = Array.from(document.querySelectorAll<HTMLButtonElement>("[data-sort]"));
    const noResults = document.getElementById("noResultsMessage") as HTMLElement | null;

    let currentSort: SortType = "default";
    let currentDirection = 1;

    function refreshIcons() {
        initIcons();
    }

    function updateNoResults() {
        if (!noResults) return;
        const visible = items.some(i => i.style.display !== "none");
        noResults.style.display = visible ? "none" : "";
    }

    function parseSku(sku: string): number {
        const match = sku.match(/\d+/);
        return match ? parseInt(match[0], 10) : 0;
    }

    function parseScale(scale: string): number {
        if (!scale) return 0;
        const parts = scale.split("/");
        return parts.length === 2 ? parseInt(parts[1], 10) : 0;
    }

    function getBaseIcon(type: SortType) {
        switch (type) {
            case "sku": return "barcode";
            case "scale": return "git-branch";
            case "price": return "dollar-sign";
            default: return "list";
        }
    }

    function updateSortUI(activeBtn: HTMLButtonElement) {

        sortButtons.forEach(btn => {
            btn.classList.remove("active");
            const icon = btn.querySelector(".sort-icon");
            if (icon) {
                const type = btn.dataset.sort as SortType;
                icon.innerHTML = `<i data-lucide="${getBaseIcon(type)}" class="h-4 w-4"></i>`;
            }
        });

        activeBtn.classList.add("active");

        if (currentSort !== "default") {
            const icon = activeBtn.querySelector(".sort-icon");
            if (icon) {
                const arrow = currentDirection === 1 ? "arrow-up" : "arrow-down";
                icon.innerHTML = `
                    <span class="inline-flex items-center gap-1">
                        <i data-lucide="${getBaseIcon(currentSort)}" class="h-4 w-4"></i>
                        <i data-lucide="${arrow}" class="h-3 w-3 opacity-70"></i>
                    </span>
                `;
            }
        }

        refreshIcons();
    }

    function filter() {
        const q = searchInput?.value.trim().toLowerCase() || "";

        items.forEach(item => {
            const title = item.textContent?.toLowerCase() || "";
            const sku = item.dataset.sku?.toLowerCase() || "";
            const match = title.includes(q) || sku.includes(q);
            item.style.display = match ? "" : "none";
        });

        updateNoResults();
    }

    function sort(type: SortType) {

        if (type === "default") {
            currentSort = "default";
            currentDirection = 1;

            const frag = document.createDocumentFragment();
            originalOrder.forEach(item => frag.appendChild(item));
            grid.appendChild(frag);

            const btn = sortButtons.find(b => b.dataset.sort === "default");
            if (btn) updateSortUI(btn);
            return;
        }

        if (currentSort === type) {
            currentDirection *= -1;
        } else {
            currentSort = type;
            currentDirection = 1;
        }

        items.sort((a, b) => {

            let r = 0;

            if (type === "sku") {
                r = parseSku(a.dataset.sku || "") - parseSku(b.dataset.sku || "");
            }

            if (type === "scale") {
                r = parseScale(a.dataset.scale || "") - parseScale(b.dataset.scale || "");
            }

            if (type === "price") {
                r = (parseFloat(a.dataset.price || "0")) - (parseFloat(b.dataset.price || "0"));
            }

            return r * currentDirection;
        });

        const frag = document.createDocumentFragment();
        items.forEach(item => frag.appendChild(item));
        grid.appendChild(frag);

        const btn = sortButtons.find(b => b.dataset.sort === type);
        if (btn) updateSortUI(btn);
    }

    searchInput?.addEventListener("input", filter);

    sortButtons.forEach(btn => {
        btn.addEventListener("click", () => {
            sort(btn.dataset.sort as SortType);
        });
    });

    sort("default");
}
